if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });

      this.setupMobileGalleryLoop();

      if (this.dataset.desktopLayout === 'thumbnail_slider') {
        this.setupDesktopMouseDrag();
        if (this.mql.matches) this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      if (this.isDesktopMouseDragEnabled()) {
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        event.detail.currentElement.classList.add('is-active');
      }

      this.playActiveMedia(event.detail.currentElement);

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    setupMobileGalleryLoop() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;

      this.mobileLoop = {
        active: false,
        preventClick: false,
        startX: 0,
        startY: 0,
        startIndex: 0,
        startTime: 0,
        clearClickTimer: null
      };

      const slider = this.elements.viewer.slider;
      const buttons = this.elements.viewer.querySelector('.slider-buttons');

      slider.addEventListener('touchstart', this.onMobileLoopStart.bind(this), { passive: true });
      slider.addEventListener('touchend', this.onMobileLoopEnd.bind(this), { passive: true });
      slider.addEventListener('touchcancel', this.onMobileLoopCancel.bind(this), { passive: true });
      slider.addEventListener('click', this.onMobileLoopClick.bind(this), true);

      if (buttons) {
        buttons.addEventListener('click', this.onMobileLoopButtonClick.bind(this), true);
      }

      this.syncMobileLoopState();

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.syncMobileLoopState.bind(this));
      } else if (this.mql.addListener) {
        this.mql.addListener(this.syncMobileLoopState.bind(this));
      }
    }

    syncMobileLoopState() {
      if (!this.elements.viewer) return;
      this.elements.viewer.enableSliderLooping = !this.mql.matches;
    }

    isMobileLoopEnabled() {
      return !this.mql.matches && this.elements.viewer && this.elements.viewer.slider;
    }

    isMobileLoopInteractiveTarget(target) {
      return target.closest('video, iframe, model-viewer, .shopify-model-viewer-ui, input, select, textarea, label, [contenteditable="true"]');
    }

    getVisibleMobileMediaItems() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return [];
      const items = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
      return items.filter((item) => item.clientWidth > 0 && item.offsetParent !== null);
    }

    getCurrentMobileMediaIndex(items) {
      if (!items || !items.length || !this.elements.viewer || !this.elements.viewer.slider) return 0;

      const slider = this.elements.viewer.slider;
      const scrollLeft = slider.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    goToMobileLoopMedia(targetItem) {
      if (!targetItem || !targetItem.dataset.mediaId || !this.elements.viewer || !this.elements.viewer.slider) return;

      this.mobileLoop.preventClick = true;
      window.clearTimeout(this.mobileLoop.clearClickTimer);
      this.mobileLoop.clearClickTimer = window.setTimeout(() => {
        this.mobileLoop.preventClick = false;
      }, 400);

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      targetItem.classList.add('is-active');

      this.preventStickyHeader();
      this.playActiveMedia(targetItem);

      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ targetItem.dataset.mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(targetItem, activeThumbnail.dataset.mediaPosition);
      }

      window.requestAnimationFrame(() => {
        this.elements.viewer.slider.scrollTo({
          left: targetItem.offsetLeft,
          behavior: 'smooth'
        });
      });
    }

    onMobileLoopStart(event) {
      if (!this.isMobileLoopEnabled()) return;
      if (!event.touches || event.touches.length !== 1) return;
      if (this.isMobileLoopInteractiveTarget(event.target)) return;

      const items = this.getVisibleMobileMediaItems();
      if (items.length < 2) return;

      const touch = event.touches[0];
      this.mobileLoop.active = true;
      this.mobileLoop.startX = touch.clientX;
      this.mobileLoop.startY = touch.clientY;
      this.mobileLoop.startIndex = this.getCurrentMobileMediaIndex(items);
      this.mobileLoop.startTime = performance.now();
    }

    onMobileLoopEnd(event) {
      if (!this.mobileLoop || !this.mobileLoop.active || !this.isMobileLoopEnabled()) return;
      if (!event.changedTouches || !event.changedTouches.length) return;

      const items = this.getVisibleMobileMediaItems();
      if (items.length < 2) {
        this.mobileLoop.active = false;
        return;
      }

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - this.mobileLoop.startX;
      const deltaY = touch.clientY - this.mobileLoop.startY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);
      const elapsed = Math.max(performance.now() - this.mobileLoop.startTime, 1);
      const velocityX = absX / elapsed;
      const threshold = Math.min(Math.max(this.elements.viewer.slider.clientWidth * 0.12, 42), 90);
      const fastSwipe = velocityX > 0.55 && absX > 28;
      let targetItem = null;

      this.mobileLoop.active = false;

      if (absY > absX * 1.15) return;
      if (absX < threshold && !fastSwipe) return;

      if (this.mobileLoop.startIndex >= items.length - 1 && deltaX < 0) {
        targetItem = items[0];
      } else if (this.mobileLoop.startIndex <= 0 && deltaX > 0) {
        targetItem = items[items.length - 1];
      }

      if (targetItem) this.goToMobileLoopMedia(targetItem);
    }

    onMobileLoopCancel() {
      if (!this.mobileLoop) return;
      this.mobileLoop.active = false;
    }

    onMobileLoopClick(event) {
      if (!this.mobileLoop || !this.mobileLoop.preventClick || !this.isMobileLoopEnabled()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.mobileLoop.preventClick = false;
    }

    onMobileLoopButtonClick(event) {
      if (!this.isMobileLoopEnabled()) return;

      const button = event.target.closest('button[name="previous"], button[name="next"]');
      if (!button) return;

      const items = this.getVisibleMobileMediaItems();
      if (items.length < 2) return;

      const currentIndex = this.getCurrentMobileMediaIndex(items);
      let targetItem = null;

      if (button.name === 'next' && currentIndex >= items.length - 1) {
        targetItem = items[0];
      } else if (button.name === 'previous' && currentIndex <= 0) {
        targetItem = items[items.length - 1];
      }

      if (!targetItem) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.goToMobileLoopMedia(targetItem);
    }

    setupDesktopMouseDrag() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;

      this.desktopDrag = {
        active: false,
        moved: false,
        preventClick: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        startScrollLeft: 0,
        startIndex: 0,
        lastX: 0,
        lastTime: 0,
        velocityX: 0,
        raf: null,
        nextScrollLeft: null,
        clearClickTimer: null
      };

      const slider = this.elements.viewer.slider;
      slider.querySelectorAll('img').forEach((image) => {
        image.setAttribute('draggable', 'false');
      });

      slider.addEventListener('dragstart', (event) => {
        if (this.isDesktopMouseDragEnabled()) event.preventDefault();
      });
      slider.addEventListener('pointerdown', this.onDesktopDragStart.bind(this));
      slider.addEventListener('pointermove', this.onDesktopDragMove.bind(this));
      slider.addEventListener('pointerup', this.onDesktopDragEnd.bind(this));
      slider.addEventListener('pointercancel', this.onDesktopDragCancel.bind(this));
      slider.addEventListener('click', this.onDesktopGalleryClick.bind(this), true);
    }

    isDesktopMouseDragEnabled() {
      return this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches && this.elements.viewer && this.elements.viewer.slider;
    }

    isDesktopDragInteractiveTarget(target) {
      return target.closest('button, a, video, iframe, model-viewer, .shopify-model-viewer-ui, input, select, textarea, label, [contenteditable="true"], [data-caleo-product-zoom-button], .product__media-toggle--zoom');
    }

    getVisibleDesktopMediaItems() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return [];
      const items = Array.from(this.elements.viewer.querySelectorAll('.product__media-item'));
      return items.filter((item) => item.clientWidth > 0 && item.offsetParent !== null);
    }

    getCurrentDesktopMediaIndex(items) {
      const activeItem = this.elements.viewer.querySelector('.product__media-item.is-active');
      const activeIndex = items.indexOf(activeItem);
      if (activeIndex > -1) return activeIndex;

      const slider = this.elements.viewer.slider;
      const scrollLeft = slider.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    requestDesktopDragScroll(slider, left) {
      if (!this.desktopDrag) return;

      this.desktopDrag.nextScrollLeft = left;
      if (this.desktopDrag.raf) return;

      this.desktopDrag.raf = window.requestAnimationFrame(() => {
        slider.scrollLeft = this.desktopDrag.nextScrollLeft;
        this.desktopDrag.raf = null;
      });
    }

    onDesktopDragStart(event) {
      if (!this.isDesktopMouseDragEnabled()) return;
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;
      if (this.isDesktopDragInteractiveTarget(event.target)) return;

      const items = this.getVisibleDesktopMediaItems();
      if (items.length < 2) return;

      const slider = this.elements.viewer.slider;
      const now = performance.now();
      this.desktopDrag.active = true;
      this.desktopDrag.moved = false;
      this.desktopDrag.pointerId = event.pointerId;
      this.desktopDrag.startX = event.clientX;
      this.desktopDrag.startY = event.clientY;
      this.desktopDrag.startScrollLeft = slider.scrollLeft;
      this.desktopDrag.startIndex = this.getCurrentDesktopMediaIndex(items);
      this.desktopDrag.lastX = event.clientX;
      this.desktopDrag.lastTime = now;
      this.desktopDrag.velocityX = 0;
      this.desktopDrag.nextScrollLeft = slider.scrollLeft;

      slider.setPointerCapture(event.pointerId);
    }

    onDesktopDragMove(event) {
      if (!this.desktopDrag || !this.desktopDrag.active || event.pointerId !== this.desktopDrag.pointerId) return;

      const slider = this.elements.viewer.slider;
      const deltaX = event.clientX - this.desktopDrag.startX;
      const deltaY = event.clientY - this.desktopDrag.startY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);
      const now = performance.now();
      const elapsed = Math.max(now - this.desktopDrag.lastTime, 16);

      this.desktopDrag.velocityX = (event.clientX - this.desktopDrag.lastX) / elapsed;
      this.desktopDrag.lastX = event.clientX;
      this.desktopDrag.lastTime = now;

      if (!this.desktopDrag.moved && absX < 5) return;
      if (!this.desktopDrag.moved && absY > absX * 1.15) return;

      this.desktopDrag.moved = true;
      slider.classList.add('is-dragging');
      this.requestDesktopDragScroll(slider, this.desktopDrag.startScrollLeft - deltaX);
      event.preventDefault();
    }

    onDesktopDragEnd(event) {
      if (!this.desktopDrag || !this.desktopDrag.active || event.pointerId !== this.desktopDrag.pointerId) return;

      const slider = this.elements.viewer.slider;
      const deltaX = event.clientX - this.desktopDrag.startX;
      const absX = Math.abs(deltaX);
      const items = this.getVisibleDesktopMediaItems();
      const velocityX = this.desktopDrag.velocityX;
      let targetIndex = this.desktopDrag.startIndex;
      const wasMoved = this.desktopDrag.moved || absX > 10;

      this.desktopDrag.active = false;
      this.desktopDrag.pointerId = null;
      slider.classList.remove('is-dragging');

      if (this.desktopDrag.raf) {
        window.cancelAnimationFrame(this.desktopDrag.raf);
        this.desktopDrag.raf = null;
      }

      try {
        if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
      } catch (error) {}

      if (!wasMoved || items.length < 2) return;

      const threshold = Math.min(Math.max(slider.clientWidth * 0.08, 32), 82);
      const fastSwipe = Math.abs(velocityX) > 0.75;

      if (absX >= threshold || fastSwipe) {
        targetIndex += deltaX < 0 ? 1 : -1;

        if (targetIndex > items.length - 1) {
          targetIndex = 0;
        } else if (targetIndex < 0) {
          targetIndex = items.length - 1;
        }
      } else {
        targetIndex = this.getCurrentDesktopMediaIndex(items);
      }

      const targetItem = items[targetIndex];

      this.desktopDrag.preventClick = true;
      window.clearTimeout(this.desktopDrag.clearClickTimer);
      this.desktopDrag.clearClickTimer = window.setTimeout(() => {
        this.desktopDrag.preventClick = false;
      }, 300);

      if (targetItem && targetItem.dataset.mediaId) {
        this.setActiveMedia(targetItem.dataset.mediaId, false, false);
      }
    }

    onDesktopDragCancel(event) {
      if (!this.desktopDrag || event.pointerId !== this.desktopDrag.pointerId) return;

      const slider = this.elements.viewer.slider;
      this.desktopDrag.active = false;
      this.desktopDrag.moved = false;
      this.desktopDrag.pointerId = null;
      slider.classList.remove('is-dragging');

      if (this.desktopDrag.raf) {
        window.cancelAnimationFrame(this.desktopDrag.raf);
        this.desktopDrag.raf = null;
      }
    }

    onDesktopGalleryClick(event) {
      if (!this.desktopDrag || !this.desktopDrag.preventClick) return;
      if (!this.isDesktopMouseDragEnabled()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.desktopDrag.preventClick = false;
    }
  });
}
